module.exports = __webpack_public_path__ + "img/backsky.69918d31.png";